let style_map = [{
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [{
                "color": "#e9e9e9"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [{
                "color": "#f5f5f5"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [{
                "color": "#ffffff"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [{
                "color": "#ffffff"
            },
            {
                "lightness": 29
            },
            {
                "weight": 0.2
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [{
                "color": "#ffffff"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [{
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [{
                "color": "#f5f5f5"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [{
                "color": "#dedede"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [{
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [{
                "saturation": 36
            },
            {
                "color": "#333333"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [{
                "color": "#f2f2f2"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [{
                "color": "#fefefe"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [{
                "color": "#fefefe"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    }
];
// var infowindow = null;
var icon = '/img/icon_map.svg';      
// var map, infoWindow, bounds;
// var id_lang = "1";

// let mapsapi = require('google-maps-api')('AIzaSyDSeUk9K3zFilsBnFJrq7uVhd8TW3j9Mzs');

// mapsapi().then(function(maps) {

$(document).ready(function (e)
{
    if (document.getElementById('mapHome'))
    {
        initMapZwykla();
    }
});


 function initMapZwykla() {   
    let map;
    // let infoWindow;
    mapZoom = parseInt(mapZoom);

    // if (mapZoom !== 'undefined') {
    //     mapZoom = 15;
    // }
    if (mapLat !== 'undefined') {

        map = new google.maps.Map(document.getElementById('mapHome'), {
            center: {
                lat: parseFloat(mapLat),
                lng: parseFloat(mapLng)
            },
            zoom: mapZoom,
            styles: style_map
        });
        let marker = new google.maps.Marker({
            position: new google.maps.LatLng(parseFloat(mapLat), parseFloat(mapLng)),
            map: map,
            icon: icon
        });

    } else {
        $('#mapsHome').fadeOut(0);
    }
}
// });